import React, { useContext } from "react";
import { IWalletHistory } from "../../../../Types";
import { Table } from "react-bootstrap";
import moment from "moment";
import LoadingSpinner from "../../../../components/loading-spinner/LoadingSpinner";
import {
  ISingleUser,
  UserContext,
} from "../../../../components/contexts/UserContext";

interface IProps {
  currentPosts: IWalletHistory[] | null;
  companyWalletBalance: string;
  isLoading: boolean;
}

function WalletHistoryTable({
  currentPosts,
  companyWalletBalance,
  isLoading,
}: IProps) {
  const { user }: any = useContext(UserContext);
  let exchangeRate: number;
  let currency = user?.currency === "USD" ? "$" : "₦"
  if (user.clause) {
    exchangeRate = user?.exchangeRate;
    
  } else {
    exchangeRate = 1;
    
  }
  return (
    <>
      <div className="app-table-container companies-table-container">
        <Table responsive="lg" className="app--table">
          <thead
            style={{
              textAlign: "left",
            }}
          >
            <tr>
              {[
                "Transaction Type",
                "Amount",
                // "Wallet Balance",
                "Transaction Date",
              ].map((COLUMN, index) => (
                <th key={index + 1}>{COLUMN}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {!isLoading &&
              currentPosts?.map((transaction, index) => (
                <tr key={index + 1}>
                  {/* Transaction type Column */}
                  <td className="td-type">
                    <div
                      className={`td-type--wrapper ${
                        transaction.walletType === "Credit"
                          ? "success-text-wrapper"
                          : "danger-text-wrapper"
                      }`}
                    >
                      {transaction.walletType}
                    </div>
                  </td>

                  {/*  Transaction Amount Column */}
                  <td className="td-amount">
                    <div className="td-amount--wrapper">
                      {currency}{(transaction.value / exchangeRate)?.toLocaleString()}
                    </div>
                  </td>

                  {/*  Wallet Balance Column */}
                  {/* <td className="td-amount">
                    <div className="td-amount--wrapper">
                      &#8358;{companyWalletBalance?.toLocaleString()}
                    </div>
                  </td> */}

                  {/*  Transaction date Column */}
                  <td className="td-walllet-balance">
                    <div className="td-walllet-balance--wrapper">
                      {moment(transaction.createdAt.date).format("L")}
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        <div className="below-table-loader-wrapper">
          {isLoading && <LoadingSpinner />}
        </div>
      </div>
    </>
  );
}

export default WalletHistoryTable;
